/**
 * leadNote — мостик «конструктор тарифа → форма заявки».
 *
 * TariffBuilder по CTA кладёт сюда текст конфигурации (по-русски — читает
 * менеджер в CRM/Telegram), LeadForm подписывается и прикладывает его в
 * `note` при отправке landingLeadSubmit. Без глобального стейт-менеджера:
 * лендинг — одна страница, двух компонентов достаточно.
 */

type Cb = (note: string | null) => void;

let current: string | null = null;
const subs = new Set<Cb>();

export function setLeadNote(note: string): void {
  current = note;
  subs.forEach((cb) => cb(current));
}

export function clearLeadNote(): void {
  current = null;
  subs.forEach((cb) => cb(current));
}

export function getLeadNote(): string | null {
  return current;
}

export function subscribeLeadNote(cb: Cb): () => void {
  subs.add(cb);
  return () => {
    subs.delete(cb);
  };
}
